import React from 'react'
import styled from 'styled-components'

interface Props {
	icon: string
	title: string
	description?: string
}

const EmptyResult: React.FC<Props> = ({ icon, title, description }) => {
	return (
		<Container>
			<Icon>{icon}</Icon>
			<Title>{title}</Title>
			{description && <Description>{description}</Description>}
		</Container>
	)
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding: 32px 12px 40px;

	@media (min-width: 768px) {
		padding: 32px 40px 40px;
	}
	width: 100%;
	min-height: 200px;
`

const Icon = styled.div`
	font-size: 48px;
	margin-bottom: 16px;
`

const Title = styled.h5`
	font-size: 22px;
	font-weight: 600;
	color: var(--text-color);
	margin: 0;
	word-break: keep-all;
`

const Description = styled.p`
	font-size: 15px;
	color: var(--sub-text-color);
	margin-top: 8px;
	margin-bottom: 0;
	word-break: keep-all;
`

export default EmptyResult
